// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const DATASTORE_ACTIONS = {
  ADD_RUNNER: 'ADD_RUNNER',
  UPDATE_RUNNER: 'UPDATE_RUNNER',
  DELETE_RUNNER: 'DELETE_RUNNER',
  SET_RUNNERS: 'SET_RUNNERS',
  ADD_WORKSPACE_FILE_PATH: 'ADD_WORKSPACE_FILE_PATH',
  ADD_WORKSPACE_FILE_PATHS: 'ADD_WORKSPACE_FILE_PATHS',
  SET_WORKSPACE_FILE_PATHS: 'SET_WORKSPACE_FILE_PATHS',
  REMOVE_WORKSPACE_FILE_PATH: 'REMOVE_WORKSPACE_FILE_PATH',
  REMOVE_WORKSPACE_FILE_PATHS: 'REMOVE_WORKSPACE_FILE_PATHS',
  TRIGGER_SAGA_FETCH_ALL_WORKSPACE_FILES: 'TRIGGER_SAGA_FETCH_ALL_WORKSPACE_FILES',
  TRIGGER_SAGA_UPLOAD_DATASTORE_FILES: 'TRIGGER_SAGA_UPLOAD_DATASTORE_FILES',
  TRIGGER_SAGA_DELETE_DATASTORE_FILES: 'TRIGGER_SAGA_DELETE_DATASTORE_FILES',
  TRIGGER_SAGA_GET_RUNNERS: 'TRIGGER_SAGA_GET_RUNNERS',
  TRIGGER_SAGA_START_DATASTORE_RUNNER: 'TRIGGER_SAGA_START_DATASTORE_RUNNER',
  SELECT_DATASTORE: 'SELECT_DATASTORE',
  SELECT_DEFAULT_DATASTORE: 'SELECT_DEFAULT_DATASTORE',
  SET_LOADING: 'SET_LOADING',
  SET_NETWORK_REQUEST_PENDING: 'SET_NETWORK_REQUEST_PENDING',
  RESET_VALIDATION_STATE: 'RESET_VALIDATION_STATE',
  SET_VALIDATION_STATE: 'SET_VALIDATION_STATE',
  UPDATE_VALIDATION_STATE: 'UPDATE_VALIDATION_STATE',
  START_RUNNER_STATUS_POLLING: 'START_RUNNER_STATUS_POLLING',
  STOP_RUNNER_STATUS_POLLING: 'STOP_RUNNER_STATUS_POLLING',
  STOP_ALL_RUNNER_STATUS_POLLINGS: 'STOP_ALL_RUNNER_STATUS_POLLINGS',
};
